export type Theme = "dark" | "light";

const STORAGE_KEY = "dondate-theme";

export function getTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage may be restricted in embedded webviews.
  }
}

export function initializeTheme(): void {
  setTheme(getTheme());
}
